<template>
  <div>
    <div class="ContentHeader">
      <div class="HeaderAll">
        <a-breadcrumb>
          <a-breadcrumb-item>
            <router-link :to="{ name: 'Home' }">Home</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>Semua Notifikasi</a-breadcrumb-item>
        </a-breadcrumb>
      </div>
    </div>

    <div class="notif-toolbar">
      <div class="paginationcustom" style="margin: 0 !important">
        <a-pagination
          showSizeChanger
          @showSizeChange="onShowSizeChange"
          :pageSizeOptions="pageSizeOption"
          :pageSize.sync="pageSize"
          :total="total"
          v-model="page"
          :showTotal="
            (total, range) => ` ${range[0]}-${range[1]}  of ${total} `
          "
          @change="handlePageChange"
        >
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }} / page</span>
          </template>
        </a-pagination>
      </div>

      <div class="notif-filter-card">
        <div class="notif-filter-group">
          <span class="notif-filter-label">
            <a-icon type="appstore" /> Kategori
          </span>
          <a-radio-group
            v-model="filterKategori"
            button-style="solid"
            size="large"
            class="notif-radio-group"
          >
            <a-radio-button value="">Semua</a-radio-button>
            <a-radio-button value="Claim">
              <img
                :src="require('@/assets/img/menu/Klaim.svg')"
                width="30"
                style="margin-right: 6px; vertical-align: middle"
              />
              Klaim
            </a-radio-button>
            <a-radio-button value="Antrian">
              <img
                :src="require('@/assets/img/menu/Antrian.svg')"
                width="30"
                style="margin-right: 6px; vertical-align: middle"
              />
              Antrian
            </a-radio-button>
          </a-radio-group>
        </div>

        <div class="notif-filter-divider"></div>

        <div class="notif-filter-group">
          <span class="notif-filter-label">
            <a-icon type="bell" /> Status Baca
          </span>
          <a-radio-group
            v-model="filterRead"
            button-style="solid"
            size="large"
            class="notif-radio-group"
          >
            <a-radio-button value="">
              <a-icon type="inbox" /> Semua
            </a-radio-button>
            <a-radio-button value="unread">
              <span class="unread-dot-inline"></span> Belum Dibaca
            </a-radio-button>
            <a-radio-button value="read">
              <a-icon type="check-circle" /> Sudah Dibaca
            </a-radio-button>
          </a-radio-group>
        </div>
      </div>
    </div>

    <simplebar
      class="simplebarcustom notif-scroll"
      data-simplebar-auto-hide="false"
    >
      <div v-if="loading" class="notif-list">
        <div v-for="i in 6" :key="i" class="notif-skeleton-wrap">
          <a-skeleton
            active
            :paragraph="{ rows: 1 }"
            :avatar="{ size: 48, shape: 'square' }"
          />
        </div>
      </div>

      <div class="notif-list" v-else-if="filteredData.length > 0">
        <div
          v-for="item in filteredData"
          :key="item.id"
          class="notif-card"
          :class="[
            item.is_read == null ? 'notif-card--unread' : 'notif-card--read',
            item.kategori === 'Claim'
              ? 'notif-card--claim'
              : 'notif-card--antrian',
          ]"
          @click="handleClick(item)"
        >
          <div class="notif-card__bar"></div>

          <div class="notif-card__icon">
            <img
              :src="
                require(`@/assets/img/menu/${
                  item.kategori === 'Claim' ? 'Klaim' : 'Antrian'
                }.svg`)
              "
              width="26"
            />
          </div>

          <div class="notif-card__body">
            <div class="notif-card__label">
              {{ item.kategori === "Claim" ? "Klaim" : "Antrian Data" }}
            </div>
            <div class="notif-card__title">
              {{
                item.kategori === "Claim"
                  ? item.nama_peserta
                  : `${item.batch_number} — ${item.nama_group}`
              }}
            </div>
          </div>

          <div class="notif-card__status">
            <div class="notif-status-wrap">
              <template v-if="item.kategori === 'Claim'">
                <img
                  :src="require('@/assets/img/icon/mv.svg')"
                  v-if="item.status == 'Menunggu Verifikasi'"
                />
                <img
                  :src="require('@/assets/img/icon/pb.svg')"
                  v-if="item.status == 'Proses Banding ke Asuransi'"
                />
                <img
                  :src="require('@/assets/img/icon/mlk.svg')"
                  v-if="item.status == 'Mohon Lengkapi Kekurangan Dokumen'"
                />
                <img
                  :src="require('@/assets/img/icon/pdg.svg')"
                  v-if="item.status == 'Pending'"
                />
                <img
                  :src="require('@/assets/img/icon/sdoa.svg')"
                  v-if="item.status == 'Sedang di-review oleh Asuransi'"
                />
                <img
                  :src="require('@/assets/img/icon/ddp.svg')"
                  v-if="item.status == 'Disetujui Dibayarkan Penuh'"
                />
                <img
                  :src="require('@/assets/img/icon/dds.svg')"
                  v-if="item.status == 'Disetujui Dibayarkan Sebagian'"
                />
                <img
                  :src="require('@/assets/img/icon/td.svg')"
                  v-if="item.status == 'Tidak Dicover'"
                />
              </template>
              <template v-else>
                <img
                  :src="require('@/assets/img/icon/reject-dm.svg')"
                  v-if="item.status == 'Dibatalkan'"
                />
                <img
                  :src="require('@/assets/img/icon/on-proses-dm.svg')"
                  v-if="item.status == 'Sedang Dalam Proses'"
                />
                <img
                  :src="require('@/assets/img/icon/verification-dm.svg')"
                  v-if="item.status == 'Menunggu Verifikasi'"
                />
                <img
                  :src="require('@/assets/img/icon/approve-dm.svg')"
                  v-if="item.status == 'Approved'"
                />
                <img
                  :src="require('@/assets/img/icon/hold-dm.svg')"
                  v-if="item.status == 'Hold'"
                />
              </template>
              <span class="notif-status-text">{{ item.status }}</span>
            </div>
          </div>

          <div class="notif-card__dot" v-if="item.is_read == null"></div>
        </div>
      </div>

      <div v-else-if="!loading" class="notif-empty">
        <a-empty>
          <div slot="description">Tidak ada notifikasi</div>
        </a-empty>
      </div>
    </simplebar>
  </div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";

export default {
  components: { simplebar },
  data() {
    return {
      data: [],
      loading: false,
      total: 0,
      page: 1,
      pageSize: 15,
      pageSizeOption: ["15", "30", "60"],
      filterKategori: "",
      filterRead: "",
    };
  },
  computed: {
    filteredData() {
      return this.data.filter((item) => {
        if (this.filterKategori && item.kategori !== this.filterKategori)
          return false;
        if (this.filterRead === "unread" && item.is_read !== null) return false;
        if (this.filterRead === "read" && item.is_read === null) return false;
        return true;
      });
    },
  },
  mounted() {
    this.fetch({ page: this.page, pageSizes: this.pageSize });
  },
  methods: {
    fetch(params = {}) {
      this.loading = true;
      this.$store
        .dispatch("GetNotification", { ...params })
        .then((response) => {
          this.loading = false;
          this.data = response.data.data;
          this.total = response.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handlePageChange(page) {
      this.fetch({ page, pageSizes: this.pageSize });
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.pageSize = pageSize;
      this.fetch({ page: current, pageSizes: pageSize });
    },
    handleClick(item) {
      if (item.is_read == null) {
        this.$store
          .dispatch("ReadNotif", { id: item.id })
          .then(() => this.navigate(item));
      } else {
        this.navigate(item);
      }
    },
    navigate(item) {
      if (item.kategori === "Claim") {
        this.$router.push({
          name: "DetailKlaim",
          params: { id: item.id_claim },
        });
      } else {
        this.$router.push({ name: "ListQueAntrianData" });
      }
    },
  },
};
</script>

<style scoped>
.notif-total-label {
  font-weight: 600;
  color: #0060d1;
  font-size: 14px;
}

.notif-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  padding-top: 15px;
}

.notif-toolbar >>> .ant-pagination-item,
.notif-toolbar >>> .ant-pagination-prev,
.notif-toolbar >>> .ant-pagination-next,
.notif-toolbar >>> .ant-pagination-jump-prev,
.notif-toolbar >>> .ant-pagination-jump-next {
  margin-right: 4px !important;
}

.notif-filter-card {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
}

.notif-filter-group {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 0 20px;
}

.notif-filter-group:first-child {
  padding-left: 0;
}

.notif-filter-group:last-child {
  padding-right: 0;
}

.notif-filter-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #77849d;
}

.notif-filter-label .anticon {
  margin-right: 4px;
}

.notif-filter-divider {
  width: 1px;
  height: 48px;
  background: #f0f2f5;
  flex-shrink: 0;
  align-self: flex-end;
  margin-bottom: 2px;
}

.notif-filter-card >>> .ant-radio-button-wrapper {
  height: 45px !important;
  line-height: 41px !important;
  font-size: 13px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.35) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-color: rgba(255, 255, 255, 0.6) !important;
  color: #4a5568 !important;
  transition: all 0.2s ease;
}

.notif-filter-card >>> .ant-radio-button-wrapper:hover {
  background: rgba(255, 255, 255, 0.55) !important;
  color: #0060d1 !important;
}

.notif-filter-card >>> .ant-radio-button-wrapper-checked {
  background: rgba(0, 96, 209, 0.75) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-color: rgba(0, 96, 209, 0.4) !important;
  color: #fff !important;
  box-shadow: 0 4px 15px rgba(0, 96, 209, 0.3) !important;
}

.notif-filter-card >>> .ant-radio-button-wrapper-checked:hover {
  background: rgba(0, 96, 209, 0.85) !important;
}

.notif-filter-card >>> .ant-radio-button-wrapper:first-child {
  border-radius: 8px 0 0 8px;
}

.notif-filter-card >>> .ant-radio-button-wrapper:last-child {
  border-radius: 0 8px 8px 0;
}

.notif-filter-card >>> .ant-select-selection {
  height: 45px !important;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.35) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.notif-filter-card >>> .ant-select-selection__rendered {
  line-height: 43px !important;
}

.unread-dot-inline {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0060d1;
  margin-right: 5px;
  vertical-align: middle;
  margin-top: -2px;
}

.notif-scroll {
  height: calc(100vh - 265px);
}

.notif-scroll >>> .simplebar-content {
  padding: 0 !important;
}

.notif-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 0 8px;
}

.notif-skeleton-wrap {
  background: #fff;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.notif-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  padding: 16px 20px 16px 24px;
  gap: 16px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.15s ease;
}

.notif-card:hover {
  box-shadow: 0 6px 20px rgba(0, 96, 209, 0.1);
  transform: translateY(-1px);
}

.notif-card__bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
}

.notif-card--claim .notif-card__bar {
  background: #0060d1;
}

.notif-card--antrian .notif-card__bar {
  background: #ff9900;
}

.notif-card--unread {
  background: #f6f9ff;
}

.notif-card--unread.notif-card--antrian {
  background: #fffcf3;
}

.notif-card__icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.notif-card--claim .notif-card__icon {
  background: #e8f0ff;
}

.notif-card--antrian .notif-card__icon {
  background: #fff3e0;
}

.notif-card__body {
  flex: 1;
  min-width: 0;
}

.notif-card__label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 3px;
}

.notif-card--claim .notif-card__label {
  color: #0060d1;
}

.notif-card--antrian .notif-card__label {
  color: #ff9900;
}

.notif-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #060d17;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notif-card--read .notif-card__title {
  font-weight: 400;
  color: #77849d;
}

.notif-card__status {
  flex-shrink: 0;
}

.notif-status-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #060d17;
  white-space: nowrap;
}

.notif-status-wrap img {
  width: 16px;
  height: 16px;
}

.notif-card__dot {
  width: 10px;
  height: 10px;
  background: #0060d1;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 0 3px rgba(0, 96, 209, 0.15);
}

.notif-empty {
  padding: 80px 0;
  text-align: center;
}
</style>
